import "./css/Normalize.css";
import "./css/Components.css";
import "./css/Getduos.css";
import Signup from "./Signup.js";
import SignupCall from "./SignupCall.js";
import Partner from "./Partner.js";
import Refer from "./Refer.js";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

export default function App() {
  const routes = [
    {
      path: "/call/:partner?",
      component: <SignupCall />,
    },
    {
      path: "/signup/:type?",
      component: <Signup />,
    },
    {
      path: "/partner",
      component: <Partner />,
    },
    {
      path: "/refer/:id?",
      component: <Refer />,
    },
    {
      path: "/",
      component: <Signup />,
    },
  ];

  return (
    <Router>
      <Switch>
        {routes.map((route) => (
          <Route path={route.path}>{route.component}</Route>
        ))}
      </Switch>
    </Router>
  );
}
